import InfinitePagination from '../../../modules/InfinitePagination';
import AcademyGridItem from './AcademyGridItem';
import { AcademyIndexGridProps } from "../../../types/components/academy/indexPage/AcademyArticleGrid";

const AcademyIndexGrid: React.FC<AcademyIndexGridProps> = ({ articles, loadNextPage }) => {


  return (
    <div cy-test-id="academy-index-grid" className="w-full grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 4k:grid-cols-4 gap-6 bg-[#252A2D]">
      {articles.data.map(article => <AcademyGridItem article={article} />)}
      <InfinitePagination
        totalPages={articles.total_pages}
        currentPage={articles.page + 1}
        getContent={loadNextPage}
      />
    </div>
  );
}

export default AcademyIndexGrid;
